import {
    inclinometerL1Icon,
    inclinometerL2Icon,
    inclinometerL3Icon,
    inclinometerL4Icon,
    inclinometerNotActiveIcon,
    inclinometerNotParameterizedIcon,
    inclinometerOKIcon,
    inclinometerNotOperationalIcon,
    laserL1Icon,
    laserL2Icon,
    laserL3Icon,
    laserL4Icon,
    laserNotActiveIcon,
    laserNotParameterizedIcon,
    laserOKIcon,
    laserNotOperationalIcon,
    laserObstructedIcon,
    infrastructureOKIcon,
    infrastructureNotActiveIcon,
    infrastructureNotOperationalIcon,
    inclinometerL0ObstructedIcon,
    inclinometerL1ObstructedIcon,
    inclinometerL2ObstructedIcon,
    inclinometerL3ObstructedIcon,
    inclinometerL4ObstructedIcon,
    laserL0ObstructedIcon,
    laserL1ObstructedIcon,
    laserL2ObstructedIcon,
    laserL3ObstructedIcon,
    laserL4ObstructedIcon
} from '../HeatMap/Marker.jsx';

export const devicesIcons = {
    laser: [
        laserNotParameterizedIcon,
        laserOKIcon,
        laserL1Icon,
        laserL2Icon,
        laserL3Icon,
        laserL4Icon
    ],
    laserObstructed: [
        laserL0ObstructedIcon,
        laserL0ObstructedIcon,
        laserL1ObstructedIcon,
        laserL2ObstructedIcon,
        laserL3ObstructedIcon,
        laserL4ObstructedIcon 
    ],
    laserNotOperational: laserNotOperationalIcon,
    laserNotActive: laserNotActiveIcon,

    inclinometer: [
        inclinometerNotParameterizedIcon,
        inclinometerOKIcon,
        inclinometerL1Icon,
        inclinometerL2Icon,
        inclinometerL3Icon,
        inclinometerL4Icon
    ],
    inclinometerObstructed: [
        inclinometerL0ObstructedIcon,
        inclinometerL0ObstructedIcon,
        inclinometerL1ObstructedIcon,
        inclinometerL2ObstructedIcon,
        inclinometerL3ObstructedIcon,
        inclinometerL4ObstructedIcon,
    ],
    inclinometerNotOperational: inclinometerNotOperationalIcon,
    inclinometerNotActive: inclinometerNotActiveIcon,

    infrastructureDeviceActiveOperational: infrastructureOKIcon,
    infrastructureDeviceNotOperational: infrastructureNotOperationalIcon,
    infrastructureDeviceNotActive: infrastructureNotActiveIcon
};